import { z } from 'zod'
import { asEnumType } from '@gqloom/zod'

export const TaxSettingType = {
  Inclusive: 'inclusive',
  Exclusive: 'exclusive',
} as const

export type TaxSettingTypeValue = (typeof TaxSettingType)[keyof typeof TaxSettingType]

export const taxSettingTypeSchema = z.enum(Object.values(TaxSettingType)).register(asEnumType, {
  name: 'TaxSettingType',
})

export const taxSettingSchema = z.object({
  taxSettingId: z.uuid(),
  taxSettingVersionId: z.uuid(),
  version: z.number().int().min(0),
  siteId: z.uuid(),
  name: z.string().min(1).max(255),
  rate: z.string().refine(
    (val) => {
      const num = parseFloat(val)
      return !isNaN(num) && num >= 0 && num <= 100
    },
    {
      message: 'Rate must be a valid number between 0 and 100',
    }
  ),
  setting: taxSettingTypeSchema,
  enabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable().optional(),
})

export const createTaxSettingInputSchema = taxSettingSchema.pick({
  name: true,
  rate: true,
  setting: true,
  enabled: true,
})

export const updateTaxSettingInputSchema = taxSettingSchema
  .pick({
    name: true,
    rate: true,
    setting: true,
    enabled: true,
  })
  .partial()

export type TaxSettingSchema = z.infer<typeof taxSettingSchema>
export type CreateTaxSettingInput = z.infer<typeof createTaxSettingInputSchema>
export type UpdateTaxSettingInput = z.infer<typeof updateTaxSettingInputSchema>
export type TaxSettingType = z.infer<typeof taxSettingTypeSchema>
